const comments = require('./_comments');
const users = require('./_users');
const stats = require('./_stats');
const tags = require('./_tags');
const track = require('./_track');

module.exports = {
	methods: {
		admin() {
			const self = this;

			return {
				comments: comments(self),
				users: users(self),
				stats: stats(self),
				tags: tags(self),
				track: track(self),
			};
		},
	},
};
